import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  styled,
  Paper,
  InputAdornment,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRight from '@mui/icons-material/KeyboardDoubleArrowRight';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ExpenseDetails = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [showEditExpenseModal, setShowEditExpenseModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState({
    expenseId: null,
    branchId: '',
    categoryId: '',
    amount: '',
    date: new Date().toISOString().split('T')[0],
    description: '',
  });
  const [branchId, setBranchId] = useState('');
  const [branches, setBranches] = useState([]);
  const [organizationId, setOrganizationId] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [description, setDescription] = useState('');

  const staticCategoryData = [
    { categoryId: 1, categoryName: 'Electronics' },
    { categoryId: 2, categoryName: 'Clothing' },
    { categoryId: 3, categoryName: 'Books' },
    { categoryId: 4, categoryName: 'Furniture' },
  ];

  const staticExpenseData = [
    { expenseId: 1, branchName: 'Branch A', categoryName: 'Electronics', amount: 1000, date: '2025-09-01', description: 'Laptop purchase' },
    { expenseId: 2, branchName: 'Branch B', categoryName: 'Clothing', amount: 500, date: '2025-09-02', description: 'Uniforms' },
    { expenseId: 3, branchName: 'Branch C', categoryName: 'Books', amount: 300, date: '2025-09-03', description: 'Textbooks' },
    { expenseId: 4, branchName: 'Branch A', categoryName: 'Furniture', amount: 1200, date: '2025-09-04', description: 'Chairs' },
    { expenseId: 5, branchName: 'Branch B', categoryName: 'Electronics', amount: 800, date: '2025-09-05', description: 'Printer' },
  ];

  useEffect(() => {
    const loadBranches = async () => {
      const user = JSON.parse(sessionStorage.getItem('user') || '{}');
      const currentOrganizationId =
        user.organization_id || user.organization?.id || user.organization || '';
      setOrganizationId(currentOrganizationId);
      if (!currentOrganizationId) return;

      try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/master/organization/${currentOrganizationId}/branches/`,
          {
            params: { organization_id: currentOrganizationId },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = response?.data;
        const branchList = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
          ? data.results
          : Array.isArray(data?.data)
          ? data.data
          : [];
        setBranches(branchList);
      } catch (error) {
        console.error('Branch API Error:', error);
        setBranches([]);
      }
    };

    loadBranches();
  }, []);

  // Handlers
  const handleEdit = (expense) => {
    setSelectedExpense(expense);
    setBranchId(expense.branchId || '');
    setCategoryId(expense.categoryId || staticCategoryData[0].categoryId);
    setAmount(expense.amount);
    setDate(expense.date);
    setDescription(expense.description);
    setShowEditExpenseModal(true);
  };

  // const handleDelete = () => setShowDeleteModal(true);
  const handleDelete = () => {
    setShowDeleteModal(true);
};

  const handleCloseDeleteModal = () =>{ setShowDeleteModal(false)
    setSnackbarMessage('Deleted successfully!');
  setOpenSnackbar(true);
  setSnackbarSeverity("success");
    ;}

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleAddExpense = () => {
    setShowAddExpenseModal(true);
    setBranchId('');
    setCategoryId('');
    setAmount('');
    setDate(new Date().toISOString().split('T')[0]);
    setDescription('');
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (branchId && categoryId && amount && date) {
      setSnackbarMessage('Expense Added Successfully');
      setOpenSnackbar(true);
      setSnackbarSeverity('success')
      setShowAddExpenseModal(false);
    } else {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleUpdate = () => {
    if (branchId && categoryId && amount && date) {
      setSnackbarMessage('Expense Updated Successfully');
      setOpenSnackbar(true);
      setSnackbarSeverity('success')
      setShowEditExpenseModal(false);
    } else {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleReset = () => {
    setBranchId('');
    setCategoryId('');
    setAmount('');
    setDate(new Date().toISOString().split('T')[0]);
    setDescription('');
  };

  const handleCancel = () => {
    setShowEditExpenseModal(false);
    setBranchId('');
    setCategoryId('');
    setAmount('');
    setDate(new Date().toISOString().split('T')[0]);
    setDescription('');
  };

  // Filter and paginate data
  const filteredData = staticExpenseData.filter((expense) =>
    expense.branchName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    expense.categoryName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    expense.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      {/* Search and Add Button */}
      <Box sx={{ display: 'flex', justifyContent:'space-between',alignItems: 'center', mb: 1, p: 2 }}>
        <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:2}}>
    <TextField
                               variant="outlined"
                               placeholder="Search..."
                               value={searchTerm}
                               onChange={(e) => setSearchTerm(e.target.value)}
                               InputProps={{
                                 startAdornment: (
                                   <InputAdornment position="start">
                                     <SearchIcon
                                       sx={{
                                         color: theme.palette.primary.main,
                                         marginLeft: 1.5,
                                         fontSize: 24,
                                       }}
                                     />
                                   </InputAdornment>
                                 ),
                                 endAdornment: searchTerm && (
                                   <InputAdornment position="end">
                                     <IconButton
                                       size="small"
                                       onClick={() => setSearchTerm('')}
                                       sx={{
                                         color: "grey",
                                         marginRight: 1,
                                       }}
                                     >
                                       <CloseIcon fontSize="small" />
                                     </IconButton>
                                   </InputAdornment>
                                 ),
                                 sx: {
                                   borderRadius: '30px',
                                   backgroundColor: theme.palette.mode === 'dark'
                                     ? 'rgba(255, 255, 255, 0.15)'
                                     : 'rgba(255, 255, 255, 1)',
                                   boxShadow: theme.palette.mode === 'dark'
                                     ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                     : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                   '& .MuiOutlinedInput-notchedOutline': {
                                     border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                   },
                                   '&:hover': {
                                     backgroundColor: theme.palette.mode === 'dark'
                                       ? 'rgba(255, 255, 255, 0.2)'
                                       : 'rgba(240, 240, 240, 1)',
                                     boxShadow: theme.palette.mode === 'dark'
                                       ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                       : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                   },
                                   '&.Mui-focused': {
                                     backgroundColor: theme.palette.mode === 'dark'
                                       ? 'rgba(255, 255, 255, 0.25)'
                                       : 'rgba(255, 255, 255, 1)',
                                     boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                     '& .MuiOutlinedInput-notchedOutline': {
                                       border: `2px solid ${theme.palette.primary.main}`,
                                     },
                                   },
                                   paddingLeft: 1.5,
                                   height: '50px',
                                   transition: 'all 0.3s ease',
                                 },
                               }}
                               sx={{
                                 width: 350,
                                 maxWidth: '100%',
                                 '& .MuiInputBase-input': {
                                   padding: '10px 14px',
                                   color: theme.palette.text.primary,
                                   fontWeight: 500,
                                 },
                               }}
                             />
        <Button
          variant="contained"
          onClick={handleAddExpense}
          sx={{
            ml: 2,
            width: "180px",
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold',
            borderRadius: '10px',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD EXPENSE
        </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mb: 2,
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>

      {/* Table */}
      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto', borderRadius: '16px' }}>
          <TableContainer>
            <Table sx={{
              width: '100%',
              tableLayout: 'fixed',
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              },
            }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Branch</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Amount</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Date</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((expense, index) => (
                    <TableRow
                      key={expense.expenseId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{expense.branchName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{expense.categoryName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>₹{expense.amount}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{expense.date}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleEdit(expense)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(expense.expenseId, expense.categoryName)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <TableCell colSpan={6} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {/* Pagination */}
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.action.hover },
                '&.Mui-disabled': { opacity: 0.3 },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.action.hover },
                '&.Mui-disabled': { opacity: 0.3 },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={(e) => {
                  const newRowsPerPage = Number(e.target.value);
                  setRowsPerPage(newRowsPerPage);
                  handleChangePage(null, 1);
                }}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Delete Modal */}
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation 
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete this expense?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Add Expense Modal */}
      <Modal open={showAddExpenseModal} onClose={() => setShowAddExpenseModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Expense
            </Typography>
            <IconButton onClick={() => setShowAddExpenseModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel htmlFor="branch" sx={{
                color: theme.palette.text.primary,
                '&.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}>Branch</InputLabel>
              <Select
                id="branch"
                value={branchId}
                label="Branch"
                onChange={(e) => setBranchId(e.target.value)}
              >
                <MenuItem value="">All Branches</MenuItem>
                {branches.map((branch) => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.branch_name || branch.name || branch.branch || `Branch ${branch.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel htmlFor="category" sx={{
                color: theme.palette.text.primary,
                '&.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}>Category</InputLabel>
              <Select
                id="category"
                value={categoryId}
                label="Category"
                onChange={(e) => setCategoryId(e.target.value)}
              >
                {staticCategoryData.map((category) => (
                  <MenuItem key={category.categoryId} value={category.categoryId}>
                    {category.categoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Amount"
              variant="outlined"
              fullWidth
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              sx={{
                mb: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}
            />
            <TextField
              label="Expense Date"
              variant="outlined"
              fullWidth
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                mb: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!branchId ? "Select Branch" : !categoryId ? "Select Category" : !amount ? "Enter Amount" : ""} arrow>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark }
                  }}
                  disabled={!branchId || !categoryId || !amount}
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Edit Expense Modal */}
      <Modal open={showEditExpenseModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Expense
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel htmlFor="branch" sx={{
                color: theme.palette.text.primary,
                '&.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}>Branch</InputLabel>
              <Select
                id="branch"
                value={branchId}
                label="Branch"
                onChange={(e) => setBranchId(e.target.value)}
              >
                <MenuItem value="">All Branches</MenuItem>
                {branches.map((branch) => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.branch_name || branch.name || branch.branch || `Branch ${branch.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel htmlFor="category" sx={{
                color: theme.palette.text.primary,
                '&.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}>Category</InputLabel>
              <Select
                id="category"
                value={categoryId}
                label="Category"
                onChange={(e) => setCategoryId(e.target.value)}
              >
                {staticCategoryData.map((category) => (
                  <MenuItem key={category.categoryId} value={category.categoryId}>
                    {category.categoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Amount"
              variant="outlined"
              fullWidth
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              sx={{
                mb: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}
            />
            <TextField
              label="Expense Date"
              variant="outlined"
              fullWidth
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                mb: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!branchId ? "Select Branch" : !categoryId ? "Select Category" : !amount ? "Enter Amount" : ""} arrow>
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark }
                  }}
                  disabled={!branchId || !categoryId || !amount}
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* User Guide Modal */}
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Expense Management - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
          <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
            {/* Section 1: Add Expense */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
            >
             ➤ Follow these steps to add a new expense:
            </Typography>
            <ul
              style={{
                marginLeft: '20px',
                lineHeight: '1.8',
                cursor: 'pointer',
              }}
            >
              <li>
                Click the <strong>"ADD EXPENSE"</strong> button at the top right to open the Add Expense modal.
              </li>
              <li>
                Select the <strong>Branch</strong> from the dropdown menu.
              </li>
              <li>
                Select the <strong>Category</strong> from the dropdown menu.
              </li>
              <li>
                Enter the <strong>Amount</strong> in the provided numeric field.
              </li>
              <li>
                Select the <strong>Expense Date</strong> using the date picker (defaults to today).
              </li>
              <li>
                Optionally, enter a <strong>Description</strong> in the multiline text field.
              </li>
              <li>
                Before clicking on <strong>"SAVE"</strong> button, review the entered information to ensure accuracy.
              </li>
              <li>
                Then click on <strong>"SAVE"</strong> button to add the expense. A success message will confirm the addition.
              </li>
              <li>
                Then the new expense record will appear in the Expense List table.
              </li>
               <li>
                If you want to reset the form, click on <strong>"RESET"</strong> button to clear the form fields and close the modal.
              </li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Branch, Category, and Amount are required fields.
            </Typography>

            {/* Section 2: Edit Expense */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
             ➤ Follow these steps to Update an existing expense:
            </Typography>
            <ul
              style={{
                marginLeft: '20px',
                lineHeight: '1.8',
                cursor: 'pointer',
              }}
            >
              <li>
                Choose the expense whose record you want to edit/update in the Expense List table.
              </li>
              <li>
                Click the <strong>Edit</strong> icon (pencil) in the Action column to open the Edit Expense modal.
              </li>
              <li>
                Update the <strong>Branch</strong>, <strong>Category</strong>, <strong>Amount</strong>, <strong>Date</strong>, or <strong>Description</strong> as needed.
              </li>
              <li>
                Before clicking on <strong>"UPDATE"</strong> button, ensure the required fields are filled.
              </li>
              <li>
                Then click on <strong>"UPDATE"</strong> button to save changes. A success message will confirm the update.
              </li>
              <li>
                If you want to reset the form, click on <strong>"CANCEL"</strong> to discard changes and close the modal.
              </li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Branch, Category, and Amount are required fields.
            </Typography>

            {/* Section 3: Delete Expense */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
             ➤ Follow these steps to delete an expense:
            </Typography>
            <ul
              style={{
                marginLeft: '20px',
                lineHeight: '1.8',
                cursor: 'pointer',
              }}
            >
              <li>
                Choose the expense whose record you want to delete in the Expense List table.
              </li>
              <li>
                Click the <strong>Delete</strong> icon (trash) in the Action column.
              </li>
              <li>
                Confirm the deletion in the modal by clicking <strong>"Yes, Delete"</strong>.
              </li>
              <li>
                The expense will be removed record from the list, and a success message will appear.
              </li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Deleted expenses cannot be recovered. Proceed with caution.
            </Typography>

            {/* Section 4: Search Expenses */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
             ➤ Follow these steps to search for an expense:
            </Typography>
            <ul
              style={{
                marginLeft: '20px',
                lineHeight: '1.8',
                cursor: 'pointer',
              }}
            >
              <li>
                Use the search bar at the top left of the Expense List.
              </li>
              <li>
                Enter the Branch Name, Category Name, or Description (or part of it) to filter the table.
              </li>
              <li>
                The table will update automatically to show matching expenses.
              </li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The search is case-insensitive and filters by Branch, Category, or Description.
            </Typography>

            {/* Section 5: Pagination */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
             ➤ Follow these steps to navigate the expense list:
            </Typography>
            <ul
              style={{
                marginLeft: '20px',
                lineHeight: '1.8',
                cursor: 'pointer',
              }}
            >
              <li>
                Use the pagination controls at the bottom to navigate through pages of expenses.
              </li>
              <li>
                Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
              </li>
              <li>
                Select a specific page number by clicking on it.
              </li>
              <li>
                Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
              </li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page.
            </Typography>

            {/* Bottom Close Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              {/* <Button
                variant="contained"
                onClick={() => setShowUserGuideModal(false)}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                  fontWeight: 'bold',
                  padding: '8px 24px',
                  borderRadius: '8px',
                }}
              >
                Close
              </Button> */}
            </Box>
          </CustomTableScrollbar>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default ExpenseDetails;